import { DataFeedInput } from '@server/data-feed/schemas/input.schema';
import { useState } from 'react';
import { trpc } from '@client-trpc';

export const useLiveTradingApi = () => {
  const [feedInputConfigs, setFeedInputConfigs] = useState<DataFeedInput[]>();

  trpc.dataFeed.liveFeedConfigs.useSubscription(undefined, {
    onData: (configs) => {
      setFeedInputConfigs(configs);
    },
    onError: (err) => {
      console.error('Subscription error:', err);
    }
  });

  const { mutate: closeFeed } = trpc.dataFeed.closeFeed.useMutation();
  const { mutateAsync: clearPersistedTrades } =
    trpc.dataFeed.clearPersistedTrades.useMutation();

  return {
    feedInputConfigs,
    closeFeed,
    clearPersistedTrades
  };
};
